import { baseService } from 'services';
import { ReliantResponse } from 'interface/apiInterface';
import {
  editClusterEP,
  getClusterEP,
  listClustersEP,
  deleteClusterEP,
} from 'services/constants';
import {
  IGetClusterResponse,
  IListClustersRequest,
  IListClustersResponse,
  IGetClusterRequest,
  IEditClusterRequest,
  IEditClusterResponse,
  IDeleteClusterRequest,
  IDeleteClusterResponse,
} from 'interface/clusterInterface';
import { AxiosError } from 'axios';

export const editCluster = async (
  data: IEditClusterRequest,
): Promise<ReliantResponse<IEditClusterResponse>> => {
  try {
    const response = await baseService.post<IEditClusterResponse>(
      editClusterEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const deleteCluster = async (
  data: IDeleteClusterRequest,
): Promise<ReliantResponse<IDeleteClusterResponse>> => {
  try {
    const response = await baseService.post<IDeleteClusterResponse>(
      deleteClusterEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const listClusters = async (
  data: IListClustersRequest,
): Promise<ReliantResponse<IListClustersResponse>> => {
  try {
    const response = await baseService.post<IListClustersResponse>(
      listClustersEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const getCluster = async (
  data: IGetClusterRequest,
): Promise<ReliantResponse<IGetClusterResponse>> => {
  try {
    const response = await baseService.post<IGetClusterResponse>(
      getClusterEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};
